import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-3c118274"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "detail"
};
var _hoisted_2 = {
  class: "content"
};
var _hoisted_3 = {
  class: "top"
};
var _hoisted_4 = {
  key: 0,
  class: "left-box",
  style: {
    "margin-right": "20px"
  }
};
var _hoisted_5 = ["src"];
var _hoisted_6 = {
  key: 1,
  class: "left-box",
  style: {
    "margin-right": "20px"
  }
};
var _hoisted_7 = ["src"];
var _hoisted_8 = {
  class: "right-box"
};
var _hoisted_9 = {
  class: "title"
};
var _hoisted_10 = {
  key: 0
};
var _hoisted_11 = {
  key: 1
};
var _hoisted_12 = {
  key: 2
};
var _hoisted_13 = {
  class: "item"
};
var _hoisted_14 = {
  key: 0
};
var _hoisted_15 = {
  key: 1
};
var _hoisted_16 = {
  key: 2
};
var _hoisted_17 = {
  class: "item"
};
var _hoisted_18 = {
  key: 0
};
var _hoisted_19 = {
  key: 1
};
var _hoisted_20 = {
  key: 2
};
var _hoisted_21 = {
  class: "item"
};
var _hoisted_22 = {
  style: {
    "margin-right": "100px"
  }
};
var _hoisted_23 = {
  style: {
    "margin-right": "100px"
  }
};
var _hoisted_24 = {
  key: 0,
  style: {
    "margin-right": "100px"
  }
};
var _hoisted_25 = {
  key: 1,
  style: {
    "margin-right": "100px"
  }
};
var _hoisted_26 = {
  class: "description"
};
var _hoisted_27 = {
  key: 0
};
var _hoisted_28 = {
  key: 1
};
var _hoisted_29 = {
  key: 2
};
var _hoisted_30 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_Head, {
    title: "投票活动",
    back: true
  }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_ctx.detail.activityTypeId == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("img", {
    src: _ctx.baseUrl + _ctx.detail.detailContent.option.picture,
    alt: ""
  }, null, 8, _hoisted_5)])) : _ctx.detail.activityTypeId == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("img", {
    src: _ctx.baseUrl + _ctx.detail.detailContent.option.picture,
    alt: ""
  }, null, 8, _hoisted_7)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_ctx.detail.activityTypeId == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_10, " 选手名称：")) : _ctx.detail.activityTypeId == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_11, " 作品名称：")) : (_openBlock(), _createElementBlock("span", _hoisted_12, " 事件名称：")), _createTextVNode(" " + _toDisplayString(_ctx.detail.detailContent.option.name), 1)]), _createElementVNode("div", _hoisted_13, [_ctx.detail.activityTypeId == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_14, " 选手编号: ")) : _ctx.detail.activityTypeId == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_15, " 作品编号: ")) : (_openBlock(), _createElementBlock("span", _hoisted_16, " 事件编号: ")), _createTextVNode(" " + _toDisplayString(_ctx.detail.detailContent.option.number) + "号 ", 1)]), _createElementVNode("div", _hoisted_17, [_ctx.detail.activityTypeId == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_18, " 选手简介: ")) : _ctx.detail.activityTypeId == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_19, " 作品简介: ")) : (_openBlock(), _createElementBlock("span", _hoisted_20, " 事件简介: ")), _createTextVNode(" " + _toDisplayString(_ctx.detail.detailContent.option.summary), 1)]), _createElementVNode("div", _hoisted_21, [_createElementVNode("span", _hoisted_22, "排名: " + _toDisplayString(_ctx.detail.detailContent.rank), 1), _createElementVNode("span", _hoisted_23, "票数: " + _toDisplayString(_ctx.detail.detailContent.option.votes) + "票", 1), _ctx.detail.detailContent.rank == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_24, "第一名")) : (_openBlock(), _createElementBlock("span", _hoisted_25, " 距上一名: " + _toDisplayString(_ctx.detail.detailContent.numgap) + "票", 1))])])]), _createElementVNode("div", _hoisted_26, [_ctx.detail.activityTypeId == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_27, " 选手详情: ")) : _ctx.detail.activityTypeId == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_28, " 作品详情: ")) : (_openBlock(), _createElementBlock("span", _hoisted_29, " 事件详情: ")), _createElementVNode("div", {
    innerHTML: _ctx.detail.detailContent.option.description
  }, null, 8, _hoisted_30)])])])], 64);
}